import {
  ValidateFirstCharIsLetter,
  ValidateTextInputPhone,
} from "#utils/formValidator";
import {
  FormInputWrapper,
  SelectInput,
  TextInput,
} from "@validereinc/common-components";
import * as PropTypes from "prop-types";
import React from "react";
import { ValidateTextInputEmail } from "../../../utils/formValidator";
import PermissionList from "../Permissions/PermissionList";
import "./ProfileForm.css";

const ProfileForm = ({
  isInvite,
  inputs,
  formState,
  availableSites,
  availableRoles,
  availableInstruments,
  availableTimezones,
  handleAccessDefinitionClick,
  hasWritePermissions,
}) => {
  // TODO: this is un-maintainable code, but leaving it untouched for now since it's Ops Hub code
  const shareProps = {
    showIcon: true,
    isDisabled: formState !== "enabled" || !hasWritePermissions,
  };

  return (
    <div className="profileForm">
      <TextInput
        {...shareProps}
        name="name"
        label="Name"
        type="text"
        placeholder="Name"
        rules={{
          validate: {
            validateName: (name) => {
              if (!ValidateFirstCharIsLetter(name)) {
                return "Name must start with a letter";
              }
              return undefined;
            },
          },
        }}
        isRequired
      />

      <TextInput
        {...shareProps}
        name="email"
        label="Email"
        type="text"
        placeholder="Email"
        rules={{
          validate: {
            validateName: (email) => {
              const checkEmail = ValidateTextInputEmail("Email", email, true);
              if (checkEmail) {
                return checkEmail;
              }
              return undefined;
            },
          },
        }}
        isDisabled={!isInvite}
        isRequired
      />

      <TextInput
        {...shareProps}
        name="phone_number"
        label="Phone Number"
        type="text"
        placeholder="000-000-0000"
        rules={{
          validate: {
            validatePhoneNumber: (val) => {
              const checkPhone = ValidateTextInputPhone(
                "phone number",
                val,
                false
              );
              if (checkPhone) {
                return checkPhone;
              }
              return undefined;
            },
          },
        }}
      />

      <TextInput
        {...shareProps}
        name="job_title"
        label="Position"
        type="text"
        placeholder="Position"
      />

      {/* @ts-expect-error legacy opshub typing */}
      <SelectInput
        {...shareProps}
        name="timezone_preference"
        label="Timezone"
        options={availableTimezones}
        isRequired
        ignoreCase
      />

      {/* @ts-expect-error legacy opshub typing */}
      <SelectInput
        {...shareProps}
        name="sites"
        label={
          <div>
            Sites
            <br />
            <div style={{ fontWeight: "normal" }}>
              Grant user access to the features and data on a site basis.
            </div>
          </div>
        }
        options={availableSites}
        labelKey="name"
        isMulti
        ignoreCase
      />

      {/* @ts-expect-error legacy opshub typing */}
      <SelectInput
        {...shareProps}
        name="role"
        label={
          <div>
            Role{" "}
            <a onClick={handleAccessDefinitionClick}>(Access Definitions)</a>
          </div>
        }
        labelKey="name"
        options={availableRoles}
        isRequired
      />

      <FormInputWrapper
        {...shareProps}
        name="permission"
        label="Permissions"
        as={() => <PermissionList list={inputs?.role?.permissions ?? null} />}
      />

      {hasWritePermissions && (
        // @ts-expect-error legacy opshub typing
        <SelectInput
          {...shareProps}
          name="restricted_calibration_instruments"
          label="Restricted Calibration Instruments"
          labelKey="name"
          options={availableInstruments}
          isMulti
        />
      )}
    </div>
  );
};

ProfileForm.propTypes = {
  isInvite: PropTypes.bool,
  inputs: PropTypes.object.isRequired,
  formState: PropTypes.string.isRequired,
  hasWritePermissions: PropTypes.bool.isRequired,
  availableSites: PropTypes.array.isRequired,
  availableRoles: PropTypes.array.isRequired,
  availableInstruments: PropTypes.array.isRequired,
  availableTimezones: PropTypes.array.isRequired,
  handleAccessDefinitionClick: PropTypes.func.isRequired,
};

export default ProfileForm;
